const soilAndCropFertilityManagementQuestionnaire = {
    "title": "土壤肥力及作物養分管理",
    "sections": [
        {
            "subject": "基本資料與評估",
            "questions": [
                {
                    "description" :"農場土壤種類",
                    "type": "oeq",
                },
                {
                    "description": "您土壤及作物施肥計畫中主要的項目",
                    "type": "mcq",
                    "options": ["輪作", "間作", "深耕", "夏季休耕", "堆肥", "農家自製禽畜肥", "外購禽畜肥", "側施", "土壤改良劑",
                                "葉面施肥", "土壤接菌", "生物動力", "綠肥翻犁或覆蓋作物", "混入作物殘體", {"value": "其他(需再填寫說明)", "elaboration": "請說明"}]
                },
                {
                    "description": "如何監控肥力管理?",
                    "type": "mcq",
                    "options": ["土壤養分檢測", "微生物檢測", "組織分析", "作物產量比較", "作物品質分析", {"value": "其他(需再填寫說明)", "elaboration": "請說明"}]
                },
                {
                    "description": "對每一種肥力監控管理多久做一次?",
                    "type": "scq",
                    "options": ["每週 ", "每月", "每年", "必需時", {"value": "其他(需再填寫說明)", "elaboration": "請說明"}]
                },
                {
                    "description": "是否土壤及植株分析或作物診斷結果顯示缺乏某些養份,所以必須添加養份?",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "接續上題,如有,請列出所缺乏的養份",
                            "type": "oeq"
                        }
                    ]
                },
                {
                    "description": "您是否使用或計畫使用限用肥力資材?",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "接續上題,如是,如何符合有機標準?",
                            "type": "oeq"
                        }
                    ]
                },
                {
                    "description": "您是否使用高鹽化的肥料(硝酸鈉,硫酸鉀等)?",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "接續上題,如是,如何避免土壤鹽化現象?",
                            "type": "oeq"
                        }
                    ]
                },
                {
                    "description": "您是否使用灰或草木灰?",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "接續上題,如是,如何確認其為未經砷化合物處理的木材?",
                            "type": "oeq"
                        }
                    ]
                },
                {
                    "description": "農場有無燃燒植物殘株?",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "接續上題,如是,請說明原因和燃燒了哪些材料?",
                            "type": "oeq"
                        }
                    ]
                },
                {
                    "description": "您是否有使用微量元素?",
                    "type": "scq",
                    "options": [{"value": "是", "elaboration": "若使用微量元素,請提供文件或檢驗報告佐證缺乏微量元素?如何評估使用成效?:file, multiple"}, "否"],
                }
            ]
        },
        {
            "subject": "堆肥與廄肥使用",
            "questions": [
                {
                    "description": "您是否使用自製堆肥?",
                    "type": "scq",
                    "options": [{"value": "是", "elaboration": "如是,請附上堆肥紀錄:file, multiple"}, "否"],
                },
                {
                    "description": "您是否使用外購堆肥?",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "接續上題,如是,請說明",
                            "type": "oeq",
                            "format": {
                                "multiple": true,
                                "fields": ["資材名稱", "品牌/來源", "成分", {"name": "允用/限用", "type": "允用|限用", "helperText": "您申請的標準驗證中對於該產品是否允許使用或有所限制"}, "每年使用次數", "使用原因"]
                            }
                        }
                    ]
                },
                {
                    "description": "您是否使用廐肥?",
                    "type": "scq",
                    "options": [{"value": "是", "elaboration": "若有使用, 請附上廐肥使用紀錄:file, multiple"}, "否"],
                }
            ]
        },
        {
            "subject": "自然資源",
            "description": ["生產作業必須維護或改善土質及水質等自然資源，應將土壤侵蝕減到最低程度，如果用水清洗或加工有機產品，則需要硝酸塩和大腸桿菌群的水質檢驗；灌溉水不得含有禁用物質而污染有機作物。"],
            "questions": [
                {
                    "description": "您如何保育土壤?",
                    "type": "mcq",
                    "options": ["梯田", "等高種植", "覆蓋物", "條植", "套作/間作", "防火林", "防風林", "保護性種植",
                                "樹線", "永久水道", "河岸管理", "蓄水池", "維護野生動植物棲息地", {"value": "其他(需再填寫說明)", "elaboration": "請說明"}]
                },
                {
                    "description": "描述您如何監控土壤保育計畫的效果?",
                    "type": "oeq"
                },
                {
                    "description": "您多久監控一次?",
                    "type": "scq",
                    "options": ["每週", "每月", "每年", "需要時", {"value": "其他", "elaboration": "請說明"}]
                },
                {
                    "description": "您是否曾發生土壤沖蝕問題?",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "承上題,如是,請說明原因及發生於哪塊田區?",
                            "type": "oeq",
                        },
                        {
                            "condition": "是",
                            "description": "請說明您如何降低上述土壤侵蝕問題?",
                            "type": "oeq"
                        }
                    ]
                },
            ]
        },
        {
            "subject": "用水",
            "questions": [
                {
                    "description": "水用於",
                    "type": "mcq",
                    "options": ["灌溉", "畜牧", "葉面噴施", "清洗作物", "溫室", "其它"]
                },
                {
                    "description": "水源",
                    "type": "mcq",
                    "options": ["井水", "泉水", "河流/溪/水塘", "自來水", "區域灌溉", {"value": "其它", "elaboration": "請說明"}]
                },
                {
                    "description": "若適用,請附上硝酸塩和大腸桿菌群的水質檢驗報告",
                    "type": "oeq",
                    "format": {
                        "multiple": false,
                        "fields": ["上傳檔案:file, optional"]
                    }
                },
                {
                    "description": "您是否有使用灌溉系統?",
                    "type": "scq",
                    "options": ["是", "否"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "灌溉系統的型態",
                            "type": "mcq",
                            "options": ["滴灌", "淹灌", "噴罐", {"value": "其他", "elaboration": "請說明"}]
                        },
                        {
                            "condition": "是",
                            "description": "灌溉系統中是否加入任何物質?",
                            "type": "scq",
                            "options": ["是", "否"],
                            "questions": [
                                {
                                    "condition": "是",
                                    "description": "承上題,若是,您使用何種物質?",
                                    "type": "oeq"
                                }
                            ]
                        },
                        {
                            "condition": "是",
                            "description": "是否清洗灌溉管路和噴嘴?",
                            "type": "scq",
                            "options": ["是", "否"],
                            "questions": [
                                {
                                    "condition": "是",
                                    "description": "承上題,如是,請說明清潔用品",
                                    "type": "oeq"
                                }
                            ]
                        },
                        {
                            "condition": "是",
                            "description": "您是否與其它經營業者共用灌溉系統?",
                            "type": "scq",
                            "options": ["是", "否"],
                            "questions": [
                                {
                                    "condition": "是",
                                    "description": "若是,他們使用何種物質於灌溉系統中或灌溉管路和噴嘴?",
                                    "type": "oeq"
                                }
                            ]
                        },
                        {
                            "condition": "是",
                            "description": "灌溉系統是否同時用於慣行和有機耕作?",
                            "type": "scq",
                            "options": ["是", "否"],
                            "questions": [
                                {
                                    "condition": "是",
                                    "description": "承上題,如何避免汙染?",
                                    "type": "oeq"
                                },
                                {
                                    "condition": "是",
                                    "description": "是否作成紀錄?",
                                    "type": "scq",
                                    "options": ["是", "否"]
                                }
                            ]
                        },
                    ]
                },
                {
                    "description": "採用何種措施以保護水質?",
                    "type": "mcq",
                    "options": ["以圍籬防止牲畜接近水道", "計畫用水以節約使用", "滴灌", "微噴霧", {"value": "其他(需再填寫說明)", "elaboration": "請說明"}]
                },
                {
                    "description": "供水系統是否有污染物?",
                    "type": "scq",
                    "options": ["是", "不適用,無汙染物"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "請列出供水系統內已知的污染物/原因/解決方法",
                            "type": "oeq",
                            "format": {
                                "multiple": true,
                                "fields": ["污染物", "原因", "解決辦法"]
                            }
                        },
                        {
                            "condition": "是",
                            "description": "請附上殘留檢驗和/或塩積度測試報告",
                            "type": "oeq"
                        }
                    ]
                },
                {
                    "description": "是否有監控水質?",
                    "type": "scq",
                    "options": ["是", "不適用, 未監控水質"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "請描述水質監控方法及頻率",
                            "type": "oeq"
                        }
                    ]
                },
                {
                    "description": "您多久進行一次水質監測?",
                    "type": "scq",
                    "options": ["每週", "每月", "每年", "需要時", {"value": "其他", "elaboration": "請說明"}]
                }
            ]
        }
    ]
}

export default soilAndCropFertilityManagementQuestionnaire;